module.exports = __webpack_public_path__ + "img_logo_bizny@2x.png?44dbb8671ff440f7fc00093ec0070167";